export enum RetestReactionStatusEnum {
    AVAILABLE = 0,
    SAMPLE_EXPIRED,
    SAMPLE_DELETED,
    PRIMER_EXPIRED,
    PRIMER_DELETED,
    REACTION_ALREADY_RETESTED,
    LIMS_PRIMER_NOT_FOUND,
    PRIMER_ARCHIVED,
    LIMS_SAMPLE_NOT_FOUND,
    REACTION_CANCELLED,
}
